import { useState } from 'react';
import Hero from './components/Hero';
import Pricing from './components/Pricing';
import WhyChooseUs from './components/WhyChooseUs';
import Booking from './components/Booking';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Pricing />
      <WhyChooseUs />
      <Booking />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
